/* RRP cart guard.
   Safety net for products sold through Kajabi (tag: kajabi-checkout). The
   template hides every add-to-cart control for them, but /cart/add can still
   be hit directly. snippets/cart-summary.liquid renders a [data-rrp-cart-guard]
   marker whenever such a line is in the cart; this script removes those lines
   and sends the shopper to the external checkout. It watches the DOM because
   Horizon re-renders the cart drawer without executing inline scripts. */
(function () {
  function handle(el) {
    if (el.dataset.rrpHandled) return;
    el.dataset.rrpHandled = '1';
    var keys = (el.dataset.keys || '').split(',').filter(Boolean);
    var redirect = el.dataset.redirect || '';
    var chain = Promise.resolve();
    keys.forEach(function (key) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      });
    });
    var go = function () {
      if (redirect) window.location.href = redirect;
      else window.location.reload();
    };
    chain.then(go).catch(go);
  }
  function scan() {
    document.querySelectorAll('[data-rrp-cart-guard]').forEach(handle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
